var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M20.776 24.398l-6.102 5.912"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M28.633 16.811l-5.464 5.291"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M23.613 30.372h6.38a4.153 4.153 0 004.153-4.153V10.758a4.153 4.153 0 00-4.153-4.153H18.856a4.153 4.153 0 00-4.153 4.153v10.467"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M28.633 21.639v-4.828h-4.829"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M14.674 25.481v4.829h4.829"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.809 14.901a3.753 3.753 0 00-2.648 3.586v13.967a3.75 3.75 0 003.751 3.751h10.061c.983 0 1.878-.378 2.547-.997"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 19.691,
    cy: 11.766,
    r: 1.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M28.902 11.766h-5.094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPair);
export default __webpack_public_path__ + "static/media/pair.a711ad0bef15e943114e2dd60aacc74b.svg";
export { ForwardRef as ReactComponent };